require("@rails/ujs").start()
require("@rails/activestorage").start()
global.$ = global.jQuery = require("jquery")

import '@claviska/jquery-minicolors'
import '@claviska/jquery-minicolors/jquery.minicolors.css'

import 'bootstrap'
import '../scss/backend.scss'
